export default __webpack_public_path__ + "static/media/logo-advanced.37f2418f.jpg";